"use client";

import * as Sentry from "@sentry/nextjs";
import { useQueryClient } from "@tanstack/react-query";
import type React from "react";

import AuthErrorModalView from "@/app/(discover)/components/auth-error-modal.view";
import { getUseApiUserDiscoverInfoQueryKey } from "@/hooks/data/use-api-user-discover-info";
import coreApiClient from "@/lib/api-clients/core-api-client";
import { useAuth } from "@/stores/use-auth";
import { usePreserveFilters } from "@/stores/use-preserve-filters";

export default function AuthErrorModalContainer(): React.JSX.Element | null {
  const { error, hasCheckedAuthStatus, isLoading, loadAuth } = useAuth();
  const queryClient = useQueryClient();
  const { clearPreservedFilters } = usePreserveFilters();

  const handleRetry = () => {
    loadAuth();
  };

  const handleSignOut = async () => {
    try {
      await coreApiClient.deleteApiAuth();
    } catch (error: unknown) {
      Sentry.captureException(error);
      console.error(error);
    } finally {
      clearPreservedFilters();
      queryClient.removeQueries({
        queryKey: getUseApiUserDiscoverInfoQueryKey(),
        exact: false,
      });
      loadAuth();
    }
  };

  if (!hasCheckedAuthStatus || error === null) {
    return null;
  }

  return (
    <AuthErrorModalView
      isOpen={true}
      error={error}
      isRetrying={isLoading}
      onRetry={handleRetry}
      onSignOut={handleSignOut}
    />
  );
}
